import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  className?: string;
}
export function CountdownTimer({
  className = ''
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 53,
    seconds: 10
  });
  useEffect(() => {
    const savedEndTime = localStorage.getItem('kitProfeEndTimeAuto');
    let endTime: number;
    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10);
      if (Date.now() > endTime) {
        endTime = Date.now() + 23 * 60 * 60 * 1000 + 53 * 60 * 1000 + 10 * 1000;
        localStorage.setItem('kitProfeEndTimeAuto', endTime.toString());
      }
    } else {
      endTime = Date.now() + 23 * 60 * 60 * 1000 + 53 * 60 * 1000 + 10 * 1000;
      localStorage.setItem('kitProfeEndTimeAuto', endTime.toString());
    }
    const interval = setInterval(() => {
      const difference = endTime - Date.now();
      if (difference <= 0) {
        const newEnd = Date.now() + 23 * 60 * 60 * 1000 + 53 * 60 * 1000 + 10 * 1000;
        localStorage.setItem('kitProfeEndTimeAuto', newEnd.toString());
        return;
      }
      setTimeLeft({
        hours: Math.floor(difference / (1000 * 60 * 60) % 24),
        minutes: Math.floor(difference / 1000 / 60 % 60),
        seconds: Math.floor(difference / 1000 % 60)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className={`flex items-center justify-center space-x-1.5 font-montserrat font-bold text-lg md:text-2xl text-brand-accent ${className}`} data-id="element-45">
      <div className="bg-brand-dark px-2 py-1 md:px-3 md:py-1.5 rounded-md border border-brand-accent/50 shadow-sm" data-id="element-46">
        {fmt(timeLeft.hours)}{' '}
        <span className="text-[9px] md:text-xs text-gray-500" data-id="element-47">hs</span>
      </div>
      <span className="text-brand-accent animate-pulse" data-id="element-48">:</span>
      <div className="bg-brand-dark px-2 py-1 md:px-3 md:py-1.5 rounded-md border border-brand-accent/50 shadow-sm" data-id="element-49">
        {fmt(timeLeft.minutes)}{' '}
        <span className="text-[9px] md:text-xs text-gray-500" data-id="element-50">min</span>
      </div>
      <span className="text-brand-accent animate-pulse" data-id="element-51">:</span>
      <div className="bg-brand-dark px-2 py-1 md:px-3 md:py-1.5 rounded-md border border-brand-accent/50 shadow-sm" data-id="element-52">
        {fmt(timeLeft.seconds)}{' '}
        <span className="text-[9px] md:text-xs text-gray-500" data-id="element-53">seg</span>
      </div>
    </div>;
}